<template>
    <div class="promo-code-filter" style="min-width: 487px; max-width: 600px">

        <div class="accordion data-filter">
            <div class="accordion-item">
                <h2 class="accordion-header" @click="isOpen=!isOpen">
                    <button class="accordion-button bold"
                            :class="{collapsed: !isOpen}"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target=".collapseFirst"
                            aria-expanded="true"
                            aria-controls="collapseFirst"
                    >
                        Filters
                    </button>
                </h2>
                <div class="accordion-collapse collapse collapseFirst"
                     :class="{ show: isOpen }"
                     data-bs-parent=".data-filter">
                    <div class="accordion-body">


                        <div class="alert alert-danger" role="alert" v-show="errors.has">
                            {{ errors.message }}
                        </div>

                        <form class="form-floating">

                            <div class="row mb-4">
                                <div class="col">
                                    <label><b>start</b> <span class="text-black-50">date</span></label>
                                    <date-picker v-model="date_from" type="date"
                                                 class="is-invalid"
                                                 :disabled-date="date => date_to > '' && date > date_to"
                                                 token="YYYY/MM/DD"
                                                 format="YYYY/MM/DD"></date-picker>
                                    <div class="invalid-feedback">
                                        <ul>
                                            <li v-for="errorMessage in errors.error.date_from">
                                                {{ errorMessage }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <label><b>end</b> <span class="text-black-50">date</span></label>
                                    <date-picker v-model="date_to" type="date"
                                                 class="is-invalid"
                                                 :disabled-date="date => date_from > '' && date < date_from"
                                                 token="YYYY/MM/DD"
                                                 format="YYYY/MM/DD"></date-picker>
                                    <div class="invalid-feedback">
                                        <ul>
                                            <li v-for="errorMessage in errors.error.date_to">
                                                {{ errorMessage }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-4">
                                <div class="col">
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                @click="onCheckboxClick('is_active')"
                                                name="is_active"
                                                id="checkbox-is_active">
                                            active
                                        </label>
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                @click="onCheckboxClick('is_used')"
                                                name="is_used">
                                            used
                                        </label>
                                    </div>
                                </div>
                            </div>


                            <div class="row text-center">
                                <div class="col align-items-center">
                                    <button type="button" class="btn btn-primary me-2" @click="onSearch">Search</button>
                                    <button type="button" class="btn btn-outline-danger me-2" @click="onClean">Clear
                                    </button>
                                </div>
                            </div>

                        </form>


                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>

export default {
    name: "PromoCodeFilter",
    props: {
        isOpenProp: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    components: {},
    data() {
        return {
            date_from: null,
            date_to: null,
            is_active: null,
            is_used: null,

            isOpen: this.isOpenProp,

            errors: {
                has: false,
                message: null,
                error: []
            },
        };
    },
    mounted() {
        this.$root.$on('onError.PromoCodeFetch', o => {
            this.errors.has = true
            this.errors.message = o.message
            this.errors.error = o.error
        })
        this._component = document.querySelector('div.promo-code-filter')
        this.clearErrors()
        this._initCheckBoxes()
    },
    methods: {
        onCheckboxClick(checkBoxName) {
            const el = this._component.querySelector('input[name="' + checkBoxName + '"]')
            if (typeof this[checkBoxName] === 'object') {
                this[checkBoxName] = true
                el.checked = true
                el.indeterminate = false
            } else {
                if (this[checkBoxName] === false) {
                    this[checkBoxName] = null
                    el.checked = null
                    el.indeterminate = true
                }
                if (this[checkBoxName] === true) {
                    this[checkBoxName] = false
                    el.checked = false
                    el.indeterminate = null
                }
            }
        },

        onSearch() {
            this.clearErrors()
            this.$emit('onFilter', {
                date_from: this.date_from,
                date_to: this.date_to,
                is_active: this.is_active,
                is_used: this.is_used,
            })
            this.isOpen = false
        },
        onClean() {
            this.clearErrors()
            this.date_from = this.date_to = null
            this.is_active = this.is_used = null
            this._initCheckBoxes()
            this.onSearch()
            this.isOpen = false
        },
        clearErrors() {
            this.errors = {
                has: false,
                message: null,
                error: []
            }
        },
        _initCheckBoxes() {
            const checkBoxes = this._component.querySelectorAll('input[type="checkbox"]')
            for(let i = 0; i < checkBoxes.length; i++) {
                checkBoxes[i].checked = null
                checkBoxes[i].indeterminate = true
            }
        },
    },
}
</script>